<template lang="html">

  <footer class="app-footer">

    <div class="container">

      <section class="top row-start ais">

        <article class="column">
          <h3><a target="_blank" href="https://www.esic.edu/empleabilidad/udp">UDP</a></h3>
          <router-link :to="$t('enlaces.ofertas')">Ofertas ESIC</router-link>
          <router-link :to="$t('enlaces.oportunidadesinternacionales')">Portales globales</router-link>
          <router-link :to="$t('enlaces.miscandidaturas')">Mis candidaturas</router-link>
        </article>


        <article class="column">

          <h3><a target="_blank" href="https://www.esic.edu/empleabilidad">Empleabilidad</a></h3>

          <a target="_blank" href="https://www.esic.edu/empleabilidad/asesoramiento">Asesoramiento</a>
          <a target="_blank" href="https://www.esic.edu/empleabilidad/recursos">Recursos</a>
          <a target="_blank" href="https://www.esic.edu/alumni/agenda">Eventos</a>
          

        </article>


        <article class="column">
          <h3><a target="_blank" href="https://www.esic.edu/empleabilidad/equipo">Contacto</a></h3>
        </article>

        
        <article class="column column-end">
          <div class="contenedor-imagen">
            <img src="@/assets/img/logo-uni-white.svg" alt="LogoEsic" width="75">
          </div>
          <nav class="rrss row-end">
            <a target="_blank" href="https://twitter.com/esiceducation"><i class="fa fa-twitter"></i></a>
            <a target="_blank" href="https://www.facebook.com/ESIC"><i class="fa fa-facebook"></i></a>
            <a target="_blank" href="https://www.linkedin.com/school/esic/"><i class="fa fa-linkedin"></i></a>
            <a target="_blank" href="https://www.instagram.com/esicbusinessschool/"><i class="fa fa-instagram"></i></a>
            <a target="_blank" href="https://www.youtube.com/ESICmarketing"><i class="fa fa-youtube"></i></a>
          </nav>
        </article>

      </section>

      <section class="bottom row-center">

        <p v-if="type == 'bs'">© 2023 ESIC Business & Marketing School. CIF: R2800828B</p>
        <p v-if="type == 'uni'">© 2023 FUNDACION DE ESTUDIOS SUPERIORES E INVESTIGACIÓN ESIC. CIF: G87046124 </p>
        <a href="https://www.esic.edu/aviso-legal" target="_blank">Política de privacidad</a>
        <a href="https://www.esic.edu/aviso-legal" target="_blank">Aviso legal</a>
      </section>

      <div class="version">v.{{version}}</div>

    </div>

  </footer>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'app-footer',
    computed:{
      ...mapGetters({
        version : 'getVersion',
        type : 'getType'
      })
    }
  }
</script>

<style scoped lang="scss">

  

</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue